import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string };

export class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(err: any): State {
    return { hasError: true, message: err?.message ?? 'Error inesperado' };
  }

  componentDidCatch(err: any, info: any) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', err, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6">
          <h1 className="text-xl font-semibold mb-2">Ha ocurrido un error</h1>
          <p className="mb-4">{this.state.message}</p>
          <button
            className="btn btn-primary"
            onClick={() => (window.location.href = window.location.pathname)}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
